import { Component, OnInit, OnDestroy, Inject, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ConditionOperator } from 'src/modules/models/enum';
import { Question } from 'src/modules/models/item/question';
import { FacilitySummary } from 'src/modules/models/asset/facility-summary';
import { QuestionUtility } from 'src/modules/models/question/question-utility';

import { AlertMessageComponent } from 'src/modules/shared/alert-message/alert-message.component';
import { Store, ICart, UpdateFacility, UpdateBookingPackage } from 'src/modules/store/index';
import { Observable } from 'rxjs';
import { BespokePackage } from 'src/modules/models/asset/bespoke-package';

import { Item } from '../../../models/item/item';
import { verifyHostBindings } from '@angular/compiler';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'opt-questionnaire',
  templateUrl: './questionnaire.component.html'
})

export class QuestionnaireComponent implements OnInit, OnDestroy {
  cart$: Observable<ICart>;
  cart_subscriber: any;
  isFormValid: boolean = true;

  // Input properties for data passed from parent modal component
  @Input() item: Item;
  @Input() facilitySummary: FacilitySummary;
  @Input() package: BespokePackage;
  @Input() isFullBookingView: boolean = false;
  @Input() booking: any;
  @Input() isReadOnly: boolean;
  @Input() data: any;
  @Input() _isSubmitAttempted :boolean;
  @Input() showButton: boolean = true ;

  answeredCurrentCount: number = 0;
  isUpsellHasQuestion: boolean = false;
  upsellTotalQuestion: number = 0;
  @Output() onSubmit = new EventEmitter<any>(true);
  isAnswerChanged: boolean = false;
  visibleQuestionsCount: number = 0;
  //itemVisibleQuestionsCount: number = 0;
  isSubmitAttempted = false;

  constructor(
    public dialog: MatDialog,
    private store: Store<any>,
    public snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
  ) {
    this.cart$ = this.store.select('cart');
    this.isSubmitAttempted = this._isSubmitAttempted;

  }

  ngOnInit() {
    // Initialize data when component receives input properties
    if (this.data) {
      if (this.data.packageFilter && this.data.packageFilter.PackageDetail) {
        this.package = this.data.packageFilter.PackageDetail;
      }
      else if (this.data.isFullBookingView == true && this.data.booking) {
        this.isFullBookingView = this.data.isFullBookingView;
        this.booking = this.data.booking;
      }
      // Set isReadOnly
      this.isReadOnly = (this.data.isReadOnly == true);
    }

    //if (this.item != undefined) {
    //  this.item.question = (data.item) ? data.item.question as Question[] : [];
    //  if (!data.isUpsellItem && this.facilitySummary.upsellSummaries && this.facilitySummary.upsellSummaries.length > 0) {
    //    this.facilitySummary.upsellSummaries.forEach((upslSum) => {
    //      if (upslSum.question) {
    //        this.isUpsellHasQuestion = true;
    //        //this.upsellTotalQuestion += upslSum.question.length;
    //        upslSum.question.forEach(question => {
    //            this.setHiddenFalseForChildQuestions(this.item.question as Question[], question.id, true);
    //            if (!question.isHidden) {
    //                this.upsellTotalQuestion += 1;
    //            }
    //        });
    //      }
    //    });
    //  } else {
    //    if (!data.isUpsellItem && data.item) {
    //      this.item.question.forEach(question => {
    //          this.setHiddenFalseForChildQuestions(this.item.question as Question[], question.id, true);
    //          if (!question.isHidden) {
    //              this.upsellTotalQuestion += 1;
    //          }
    //      });
    //    }

    //  }
    //}

    this.countAnswer();

  }

  ngOnDestroy() {
    if (this.cart_subscriber) {
      this.cart_subscriber.unsubscribe();
    }
  }

  updateQuestion(ques) {
    this.isAnswerChanged = true;
    this.countAnswer();
  }

  //countAnswer() {
  //    var quesCount = 0;
  //  var count = 0;
  //  this.isFormValid = true;
  //  if (!this.isFullBookingView) {
  //    if (this.item) {
  //      if (!this.data.isUpsellItem) {
  //          for (var q of this.item.question) {
  //                  var isQuestionAnswered = this.isAnswerd(this.item.question, q);
  //                  if (!q.isHidden) {
  //                      quesCount++
  //                      if (isQuestionAnswered) {
  //                          count++;
  //                      } else if ((q.type == 'textQuestion' || q.type == 'booleanQuestion' || q.type == 'singleChoiceQuestion' || q.type == 'fileUploadQuestion')
  //                          && (q.answeredText !== undefined && q.answeredText != null && q.answeredText != '') && q.mandatory !== undefined) {
  //                          count++;
  //                      } else if (q.type == 'multipleChoiceQuestion') {
  //                          var answeredCount = 0;
  //                          if (q.bookingQuestionChoices && q.isBookingQuestion) {
  //                              q.bookingQuestionChoices.forEach((answ, indx) => {
  //                                  //if (q.quantityRequired) {
  //                                  //    if (answ.Quantity>0) {
  //                                  //        answeredCount++;
  //                                  //    }
  //                                  //} else if (answ.isSelectedAnswer) {
  //                                  //    answeredCount++;
  //                                  //}
  //                                  if (answ.isSelectedAnswer) {
  //                                      answeredCount++;
  //                                  }
  //                              });
  //                              if (answeredCount > 0) {
  //                                  count++;
  //                              }
  //                          } else if (q.answerChoices && !q.isBookingQuestion) {
  //                              q.answerChoices.forEach((answ, indx) => {
  //                                  if (q.quantityRequired) {
  //                                      if (answ.Quantity) {
  //                                          answeredCount++;
  //                                      }
  //                                  } else if (answ.isSelectedAnswer) {
  //                                      answeredCount++;
  //                                  }
  //                              });
  //                              if (answeredCount > 0) {
  //                                  count++;
  //                              }
  //                          }
  //                          if (q.mandatory && answeredCount == 0) {
  //                              this.isFormValid = false;
  //                          }
  //                      }
  //                      else if (q.mandatory) {
  //                          this.isFormValid = false;
  //                      }
  //                  }
  //        }
  //      }

  //      if (this.facilitySummary.upsellSummaries) {
  //        this.facilitySummary.upsellSummaries.forEach((upsl, i) => {
  //            if (upsl.question) {
  //                for (var q of upsl.question) {

  //                    var isQuestionAnswered = this.isAnswerd(upsl.question, q); // Call to isAnswerd method
  //                    if (!q.isHidden) {
  //                        quesCount++
  //                        if (isQuestionAnswered) {
  //                            count++;
  //                        } else if ((q.type == 'textQuestion' || q.type == 'booleanQuestion' || q.type == 'singleChoiceQuestion')
  //                            && (q.answeredText !== undefined && q.answeredText != null && q.answeredText != '')
  //                            && q.mandatory !== undefined) {
  //                            count++;
  //                        } else if (q.type == 'multipleChoiceQuestion') {
  //                            var answeredCount = 0;
  //                            if (q.bookingQuestionChoices && q.isBookingQuestion) {
  //                                q.bookingQuestionChoices.forEach((answ, indx) => {
  //                                    if (q.quantityRequired) {
  //                                        if (answ.Quantity) {
  //                                            answeredCount++;
  //                                        }
  //                                    } else if (answ.isSelectedAnswer) {
  //                                        answeredCount++;
  //                                    }
  //                                });
  //                                if (answeredCount > 0) {
  //                                    count++;
  //                                }
  //                            } else if (q.answerChoices && !q.isBookingQuestion) {
  //                                q.answerChoices.forEach((answ, indx) => {
  //                                    if (q.quantityRequired) {
  //                                        if (answ.Quantity) {
  //                                            answeredCount++;
  //                                        }
  //                                    } else if (answ.isSelectedAnswer) {
  //                                        answeredCount++;
  //                                    }
  //                                });
  //                                if (answeredCount > 0) {
  //                                    count++;
  //                                }
  //                                if (q.mandatory && answeredCount == 0) {
  //                                    this.isFormValid = false;
  //                                }
  //                            }
  //                        } else if (q.mandatory) {
  //                            this.isFormValid = false;
  //                        }
  //                    }
  //                }
  //            }
  //        });
  //      }
  //      this.item.totalAnsweredQuestions = count;
  //      this.item.totalQuestions = quesCount;
  //    }
  //    let totalPackageAnsweredQuestions = 0;
  //    let packageQuesTotal = 0;
  //    if (this.package) {
  //        for (var question of this.package.question) {

  //            var isQuestionAnswerd = this.isAnswerd(this.package.question, question);
  //            if (!question.isHidden) {
  //                packageQuesTotal++
  //                if (isQuestionAnswerd) {
  //                    totalPackageAnsweredQuestions++;
  //                }
  //            }
  //      }
  //        this.package.totalAnsweredQuestions = totalPackageAnsweredQuestions;
  //        this.package.totalQuestions = packageQuesTotal;
  //    }
  //    this.answeredCurrentCount = count + totalPackageAnsweredQuestions;
  //  }
  //  //Booking Questions
  //  else if (this.isFullBookingView) {
  //    if (this.booking) {
  //      if (this.booking.packageQuestion && this.booking.packageQuestion.length > 0) {
  //        this.booking.totalAnsweredPackageQuestions = 0;
  //        for (var pQuestion of this.booking.packageQuestion) {

  //            var isQuestionAnswerd = this.isAnswerd(this.booking.packageQuestion, pQuestion);
  //            if (!pQuestion.isHidden) {
  //                this.booking.totalPackageQuestions++;
  //                if (isQuestionAnswerd) {
  //                    this.booking.totalAnsweredPackageQuestions++;
  //                    //count++;
  //                }
  //            }
  //        }
  //      }
  //      if (this.booking.facilitySummaries && this.booking.facilitySummaries.length > 0) {
  //        for (var facilitySummary of this.booking.facilitySummaries) {
  //          facilitySummary.totalQuestions = 0;
  //          facilitySummary.totalAnswerdQuestions = 0;
  //          if (facilitySummary.bookingItemSummaries && facilitySummary.bookingItemSummaries.length > 0) {
  //            for (var bookingitemSummary of facilitySummary.bookingItemSummaries) {
  //              if (bookingitemSummary.question && bookingitemSummary.question.length > 0) {
  //                // item question
  //                for (var itemQuestion of bookingitemSummary.question) {

  //                    var isQuestionAnswerd = this.isAnswerd(bookingitemSummary.question, itemQuestion);
  //                    if (!itemQuestion.isHidden) {
  //                        if (isQuestionAnswerd) {
  //                            facilitySummary.totalAnswerdQuestions++;
  //                            //count++;
  //                        }
  //                        facilitySummary.totalQuestions++;
  //                    }
  //                }
  //              }

  //              // upsell item question
  //              if (bookingitemSummary.upsellSummaries && bookingitemSummary.upsellSummaries.length > 0) {

  //                bookingitemSummary.isUpsellHasQuestion = false;

  //                for (var upsellSummary of bookingitemSummary.upsellSummaries) {
  //                  if (upsellSummary.question && upsellSummary.question.length > 0) {
  //                    for (var upsellQuestion of upsellSummary.question) {

  //                            //even if one upsell has question it should be shown
  //                            bookingitemSummary.isUpsellHasQuestion = true;

  //                            var isQuestionAnswerd = this.isAnswerd(upsellSummary.question, upsellQuestion);
  //                            if (!upsellQuestion.isHidden) {
  //                                if (isQuestionAnswerd) {
  //                                    facilitySummary.totalAnswerdQuestions++;
  //                                    //count++;
  //                                }
  //                                facilitySummary.totalQuestions++;
  //                            }
  //                    }
  //                  }//else{
  //                  //     bookingitemSummary.isUpsellHasQuestion = false;
  //                  // }
  //                }
  //              } else {
  //                bookingitemSummary.isUpsellHasQuestion = false;
  //              }
  //            }
  //          }

  //        }
  //      }

  //    }
  //  }
  //}


 countAnswer() {
  let quesCount = 0;
  let ansCount = 0;
  this.isFormValid = true;

  // ------------------------------
  // Case 1: Facility / Item View
  // ------------------------------
  if ((!this.isFullBookingView && (this.data?.item|| this.item)) || (this.data?.packageFilter?.PackageDetail || this.package)) {

    if(this.item==undefined){
      this.item = this.data.item;
    }
    else if (this.package == undefined) {
      this.package = this.data.package;
    }

    // Item questions
    if (!this.data?.isUpsellItem && Array.isArray(this.item?.question)) {
      this.item.question.forEach((q, index) => {
        q.isAnswered = this.isAnswerd(this.item.question, q);
        q.columnWidth = this.getQuestionWidth(this.item.question, index);
        q.isColumnQues = q.columnWidth !== '100%';
        q.isExpanded = q.isColumnQues;
      });
      quesCount += this.item.question.filter(x => !x.isHidden)?.length ?? 0;
      ansCount += this.item.question.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
    }

    // Upsell questions - Always check this regardless of item questions
    if (Array.isArray(this.facilitySummary?.upsellSummaries)) {
      this.facilitySummary.upsellSummaries.forEach(upsl => {
        if (Array.isArray(upsl.question)) {
          upsl.question.forEach((q, index) => {
            q.isAnswered = this.isAnswerd(upsl.question, q);
            q.columnWidth = this.getQuestionWidth(upsl.question, index);
            q.isColumnQues = q.columnWidth !== '100%';
            q.isExpanded = q.isColumnQues;
          });
          quesCount += upsl.question.filter(x => !x.isHidden)?.length ?? 0;
          ansCount += upsl.question.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
        }
      });
    }

    // Save item totals if item exists
    if (this.item) {
      this.item.totalAnsweredQuestions = ansCount;
      this.item.totalQuestions = quesCount;
    }

    // Package questions
    if (Array.isArray(this.package?.question)) {
      this.package.question.forEach((q, index) => {
        q.isAnswered = this.isAnswerd(this.package.question, q);
        q.columnWidth = this.getQuestionWidth(this.package.question, index);
        q.isColumnQues = q.columnWidth !== '100%';
        q.isExpanded = q.isColumnQues;
      });

      this.package.totalAnsweredQuestions =
        this.package.question.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
      this.package.totalQuestions =
        this.package.question.filter(x => !x.isHidden)?.length ?? 0;
    }

    // Final answered count
    this.answeredCurrentCount = ansCount + (this.package?.totalAnsweredQuestions ?? 0);
  }

  // ------------------------------
  // Case 2: Full Booking View
  // ------------------------------
  else if (this.isFullBookingView && this.booking) {

    // Package questions
    if (Array.isArray(this.booking.packageQuestion)) {
      let index = 0;
      this.booking.packageQuestion.forEach(pQuestion => {
        if (Array.isArray(pQuestion.packageQuestions)) {
          pQuestion.packageQuestions.forEach(pq => {
            pq.isAnswered = this.isAnswerd(pQuestion.packageQuestions, pq);
            pq.columnWidth = this.getQuestionWidth(pQuestion.packageQuestions, index++);
            pq.isColumnQues = pq.columnWidth !== '100%';
            pq.isExpanded = pq.isColumnQues;
          });
          pQuestion.totalPackageQuestions = pQuestion.packageQuestions.filter(x => !x.isHidden)?.length ?? 0;
          pQuestion.totalAnsweredPackageQuestions = pQuestion.packageQuestions.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
        }
      });
    }

    // Facility summaries
    if (Array.isArray(this.booking.facilitySummaries)) {
      this.booking.facilitySummaries.forEach(facilitySummary => {
        facilitySummary.totalQuestions = 0;
        facilitySummary.totalAnswerdQuestions = 0;

        if (Array.isArray(facilitySummary.bookingItemSummaries)) {
          facilitySummary.bookingItemSummaries.forEach(bookingitemSummary => {
            // Item questions
            if (Array.isArray(bookingitemSummary.question)) {
              let index = 0;
              bookingitemSummary.question.forEach(itemQuestion => {
                itemQuestion.isAnswered = this.isAnswerd(bookingitemSummary.question, itemQuestion);
                itemQuestion.columnWidth = this.getQuestionWidth(bookingitemSummary.question, index++);
                itemQuestion.isColumnQues = itemQuestion.columnWidth !== '100%';
                itemQuestion.isExpanded = itemQuestion.isColumnQues;
              });
              facilitySummary.totalQuestions += bookingitemSummary.question.filter(x => !x.isHidden)?.length ?? 0;
              facilitySummary.totalAnswerdQuestions += bookingitemSummary.question.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
            }

            // Upsell item questions
            bookingitemSummary.isUpsellHasQuestion = false;
            if (Array.isArray(bookingitemSummary.upsellSummaries)) {
              bookingitemSummary.upsellSummaries.forEach(upsellSummary => {
                if (Array.isArray(upsellSummary.question)) {
                  let index = 0;
                  upsellSummary.question.forEach(upsellQuestion => {
                    bookingitemSummary.isUpsellHasQuestion = true; // even if one exists
                    upsellQuestion.isAnswered = this.isAnswerd(upsellSummary.question, upsellQuestion);
                    upsellQuestion.columnWidth = this.getQuestionWidth(upsellSummary.question, index++);
                    upsellQuestion.isColumnQues = upsellQuestion.columnWidth !== '100%';
                    upsellQuestion.isExpanded = upsellQuestion.isColumnQues;
                  });
                  this.upsellTotalQuestion += upsellSummary.question.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
                  facilitySummary.totalQuestions += upsellSummary.question.filter(x => !x.isHidden)?.length ?? 0;
                  facilitySummary.totalAnswerdQuestions += upsellSummary.question.filter(x => !x.isHidden && x.isAnswered)?.length ?? 0;
                }
              });
            }
          });
        }
      });
    }
  }
}


  isAnswerd(question: Question[], q) {
    let IsValid = true;
    var isQuestionAnswerd = false;
    let conditionalQuestionAnswerToValidate = [];

    if ((
      (q.type == 'textQuestion' || q.type == 'booleanQuestion' || q.type == 'singleChoiceQuestion' || q.type == 'richTextQuestion') ||
      (q.type == 'textQuestionAnswer' || q.type == 'booleanQuestionAnswer' || q.type == 'singleChoiceQuestionAnswer' || q.type == 'richTextQuestionAnswer')
    )
      && (q.answeredText !== undefined && q.answeredText != null && q.answeredText != '')) {

      isQuestionAnswerd = true;

      if (q.type == 'booleanQuestion' || q.type == 'booleanQuestionAnswer') {
        conditionalQuestionAnswerToValidate.push((q.answeredText == 'Yes' ? 'true' : 'false'))
      } else {
        conditionalQuestionAnswerToValidate.push(q.answeredText);
      }

    }
    else if (q.type == 'multipleChoiceQuestion' || q.type == 'multipleChoiceQuestionAnswer') {
      var selectedAnswerIds = [];

      //if booking view bookingQuestionChoices will be considered package and item question scenario answerChoices
      var _choices = q.isBookingQuestion ? q.bookingQuestionChoices : q.answerChoices;
      if ((_choices ?? []).length > 0) {
        _choices.forEach((answ, indx) => {
          if (answ.isSelectedAnswer) {
            conditionalQuestionAnswerToValidate.push(answ.id);

            let _qtyReq = q.question?.quantityRequired || q.quantityRequired;
            if ((_qtyReq && answ.Quantity > 0) || !_qtyReq) {
              selectedAnswerIds.push(answ.id);
            } else {
              IsValid = false;//qty req question does not have qty
            }
          }
        });
      }
      if (selectedAnswerIds.length > 0) {
        isQuestionAnswerd = true;
      }


    } else if (q.type == 'fileUploadQuestion') {
      if (q.answerUploadedFiles) {
        let minCount: number = q.question?.minCount ?? q.minCount;
        let maxCount: number = q.question?.maxCount ?? q.maxCount;
        // Filter out files marked for deletion
        const validFiles = q.answerUploadedFiles.filter(file => file.isDelete === undefined || file.isDelete !== true);

        if (validFiles.length > 0) {
          const count = validFiles.length;
          if ((minCount && count < minCount) || (maxCount && count > maxCount)) {
            isQuestionAnswerd = false;
          } else {
            isQuestionAnswerd = true;
          }
        } else {
          isQuestionAnswerd = false;
        }
      }
    } else if (q.type == 'dateAndTimeQuestion') {
          // Check if date is required and provided
          if (q.answerDate || q.answerDateAndTime) {
              if (q.date !== undefined && q.date != null) {
                  isQuestionAnswerd = true;
                  conditionalQuestionAnswerToValidate.push(q.date.toString());
              } else {
                  isQuestionAnswerd = false;
              }
          }
          
          // Check if time is required and provided
          if (q.answerTime || q.answerDateAndTime) {
              if (q.time !== undefined && q.time != null) {
                  isQuestionAnswerd = true;
                  if (q.time) {
                      conditionalQuestionAnswerToValidate.push(q.time.toString());
                  }
              } else if (!q.answerDate && !q.answerDateAndTime) {
                  // Only time is required, so if not provided, question is not answered
                  isQuestionAnswerd = false;
              }
          }
          
          // For dateAndTime, both must be provided
          if (q.answerDateAndTime) {
              isQuestionAnswerd = (q.date !== undefined && q.date != null) && (q.time !== undefined && q.time != null);
          }
      }

    if (q.mandatory && !isQuestionAnswerd) {
      q.isMandatoryUnanswered = true;
    } else {
      q.isMandatoryUnanswered = false;
    }

    QuestionUtility.checkForConditionalQuestion(question, q, conditionalQuestionAnswerToValidate);

    //if((q.type == 'textQuestion' || q.type == 'booleanQuestion' || q.type == 'singleChoiceQuestion' || q.type == 'fileUploadQuestion' ) && q.isHidden == true){
    //  isQuestionAnswerd = true;
    //}

    if (!q.isHidden && (!IsValid || (q.mandatory && !isQuestionAnswerd))) {
      this.isFormValid = false;
    }
    //this.updateVisibleQuestionsCount(question);
    return isQuestionAnswerd;

  }

  submitBookingData() {
    console.log('submitBookingData', this.booking);
    this.isSubmitAttempted = true;
    // return;
    if (this.isFormValid) {
      if (this.isFullBookingView) {
        this.onSubmit.emit({ booking: this.booking, isAnswerChanged: this.isAnswerChanged });
        this.dialog.closeAll();
      }
    } else {
      this.openSnackBarError(['Please fill all the mandatory questions.']);
    }

  }


  submitData(data) {
    this.isSubmitAttempted = true;
    this.countAnswer();
    if (this.isFormValid) {
      if (!this.isFullBookingView && this.data.isEditMode == true) {
        this.onSubmit.emit(this.item);
        return;
      }
      if (this.package) {
        this.data.packageFilter.PackageDetail = this.package;
        this.store.dispatch(new UpdateBookingPackage(this.data.packageFilter));
        this.onSubmit.emit(this.package);
        return;
      }
      if (this.data.isUpsellItem) {
        let item = this.facilitySummary.upsellSummaries.filter(us => us.id == this.item.id)[0];
        if (item != undefined) {
          item.question = this.item.question;
        }
      } else {
        this.facilitySummary.item.question = this.item.question;
      }
      this.store.dispatch(new UpdateFacility(this.facilitySummary));
      this.onSubmit.emit(this.item);
    } else {
      this.openSnackBarError(['Please fill all the mandatory questions.']);
    }
  }

  openSnackBarError(message) {
    this.snackBar.openFromComponent(AlertMessageComponent, {
      data: message,
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  generateRandomName(): string {
    return 'answer-radio-groupUpsell' + Math.random().toString(36).substring(2);
  }


  //updateVisibleQuestionsCount(question: Question[]): void {

  //  this.visibleQuestionsCount = question.filter(question => !question.isHidden).length;

  //}


  questionAnswered(question: Question[], event: any, questionId, selectedChoice) {
    this.countAnswer();
    this.isAnswerd(question, question);
  }

  getSanitizedHtml(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
  getQuestionWidth(questions: Question[], currentIndex: number): string {
    //first Item
    var mincolWidth = '10%';
    if ((questions[currentIndex]?.primaryQuestionId ?? "") != "") {
      const childQuestions = questions.filter(qs => qs?.primaryQuestionId === questions[currentIndex]?.primaryQuestionId && qs.isHidden === false);
      if (childQuestions.length > 0) {
        const nonHorizontalCount = childQuestions.filter(qs => !qs?.displayQuestionHorizontally).length;
        const totalCount = childQuestions.length;
        const effectiveCount = totalCount - nonHorizontalCount;
        if (effectiveCount > 0) {
          mincolWidth = (Math.floor(100 / effectiveCount) - 2) + '%';
        }
      }
    }
    if ((questions[currentIndex]?.displayQuestionHorizontally ?? false)) {
      if (currentIndex == 0) {
        //check next question is same group column questio
        if ((questions[currentIndex + 1]?.displayQuestionHorizontally ?? false)) {
          if (questions[currentIndex + 1]?.primaryQuestionId == questions[currentIndex]?.primaryQuestionId) {
            return mincolWidth;
          }
        }
        return '100%'
      } else if (currentIndex == (questions.length - 1)) {
        //check prev question is same group column question
        if ((questions[currentIndex - 1]?.displayQuestionHorizontally ?? false)) {
          /*  if (this.questions[currentIndex- 1].question.primaryQuestionId == this.questions[currentIndex].question.primaryQuestionId) {
             return mincolWidth;
           } */
          return mincolWidth;
        }
        return '100%'
      } else {
        if (
          //check prev question is column
          ((questions[currentIndex - 1]?.displayQuestionHorizontally ?? false) &&
            questions[currentIndex - 1]?.primaryQuestionId == questions[currentIndex]?.primaryQuestionId) ||
          //check next question is column
          ((questions[currentIndex + 1]?.displayQuestionHorizontally ?? false) &&
            questions[currentIndex + 1]?.primaryQuestionId == questions[currentIndex]?.primaryQuestionId)
        ) {
          return mincolWidth;
        }
      }
    }
    return '100%'
  }

  getPakgeName(packageId: string = "", booking: any): string {
    let pakageName = ''
    if (packageId != "") {
      booking?.bookingPackages.forEach(bookingPackage => {
        if ((bookingPackage?.id ?? "") == packageId) {
          pakageName = bookingPackage.name;
        }
      })
    }
    return pakageName
  }
}
